export { default as AppleLogo } from './apple-logo';
